angular.module('rjmNg.directives').directive 'chart', [
  "chartFormatterService"
  "$location"
  "$timeout"
  "$window"
  "chartRenderQueue"
  "colorThemeService"
  (chartFormatterService, $location, $timeout, $window, chartRenderQueue, colorThemeService) ->
    restrict: "E"
    template: "<div></div>"
    replace: true
    priority: 200
    require: [
      "chart"
      "?^gridster"
    ]
    scope:
      chart: "="
      exporting: "="
    controller: [
      "$scope"
      "$element"
      "$attrs"
      ($scope, $element, $attrs) ->
        resizePromise = null
        type: null
        highChart: null
        table: null
        @resize = (width, height) ->

          # Cache these for later operations like tooltip rendering
          $scope.chartWidth = width
          $scope.chartHeight = height

          #the chart has not been rendered so abort
          if not @type? and $scope.chart?.data?
            @renderChart()
            return
          else if not @type?
            return

          $element.parent().addClass("blocked")
          $timeout =>
            switch @type
              when 'highChart'
                @highChart.setSize(width - 2, height - 52, false)
              when "table"
                @table.fnAdjustColumnSizing()
                settings = @table.fnSettings()
                headerRowHeight = $element.find('thead').height()
                settings.oScroll.sY = height - 42 - headerRowHeight
                settings._iDisplayLength = Math.ceil((height - 42 - headerRowHeight) / 28)
                @table.fnDraw()
              when 'scalar'
                @scalarFontSizer(height - 52)
            $element.parent().removeClass("blocked")
          , 0
          , false

        @scalarFontSizer = (elementHeight) ->
          #get and set the intial font size to the height of the chart element
          fontSize = elementHeight * .7
          $element.find('span').css('font-size', fontSize)

        @getHighchartStandardOptions = (chart) ->
          formattedSeries = chartFormatterService.getFormattedSeries(chart, $scope.range)
          for id, series of formattedSeries
            series.color = colorThemeService.pickColor(id)
          xAxis:
            title:
              text: null
            categories : chart.data.categories
            tickmarkPlacement: "on"
            labels:
              rotation: 0
              overflow: "justify"
              align: chartFormatterService.getXAxisLabelAlignment(chart.highchartStyle)
              step : chartFormatterService.getStep(chart.highchartStyle, chart.data.categories)
              style:
                width: '500px'
              y: chartFormatterService.getXAxisLabelY(chart.highchartStyle)
              formatter: ->
                toReturn = this.value

                if(toReturn?.length > 22)
                  toReturn = toReturn.substr(0, 19) + "..."

                return toReturn;
          yAxis:
            min: chartFormatterService.getSuffixAdjustedValue( Math.min(0,$scope.range.min), chart.data.suffix)
            labels:
              overflow: "justify"
              formatter: () ->
                toReturn = this.value
                if chart.suffix is "%"
                  toReturn *= 100
                decimalPlaces = 0

                if(toReturn >= 1000000)
                  if((toReturn % 1000000) != 0)
                    decimalPlaces = Math.max(1, decimalPlaces)

                  toReturn = (this.value / 1000000).toFixed(decimalPlaces) + 'M'
                else if(toReturn >= 1000)
                  if((toReturn % 1000) != 0)
                    decimalPlaces = Math.max(1, decimalPlaces)

                  toReturn = (this.value / 1000).toFixed(decimalPlaces) + 'K'

                return chart.data.prefix + toReturn + chart.data.suffix
            plotLines: [{
                value: 0
                width: 1
                color: '#aaaaaa'
            }]
          series: formattedSeries

        @getHighchartsPieChartOptions = (chart) ->

          dataLabels = []
          for i in [0..chart.data.categories.length-1]
            category = chart.data.categories[i].toString()

            # Highcharts needs this to ne a number, so parse it before passing it in
            value = parseFloat( chartFormatterService.getSuffixAdjustedValue(chart.data.series[0].data[i], chart.data.suffix) )

            dataLabels.push([category, value])
          series: [
            type: 'pie'
            data: dataLabels
          ]

        @renderHighchart = (chart) ->
          $element.addClass("figure-content-highchart")
          @type = "highChart"
          basicOptions =
            chart:
              renderTo: $element[0]
              defaultSeriesType: chart.highchartStyle
              reflow: false
              zoomType: 'xy'
              backgroundColor: if $scope.exporting then "white" else "transparent"
            legend:
              enabled: chartFormatterService.isMultiSeries(chart)
              borderWidth: 0
              itemStyle:
                color: "#333"
                fontSize: "11px"
            tooltip:
              followPointer: true
              shared: false
              useHTML: true
              formatter: ->
                chartContainer = $element[0]

                # In Highcharts you can hide a series.  If we're hiding it, hide it from the tooltips as well
                visibleSeries = []
                for series in $(chartContainer).highcharts().series
                  visibleSeries.push series.visible

                # Determine which type of tooltip we need
                if chartFormatterService.getSharedTooltip(chart.data.categories, chart.data.series, chart.chartStyle, chart.highchartStyle, this, visibleSeries, $element.height(), $scope.range.min) # If true, this uses shared formatting
                  $(chartContainer).children().css({overflow:"visible"})

                  tooltipDiv = '<div class="chartTooltip">'
                  tooltipHeader = '<h4>'+this.x+'</h4>'
                  tooltipHTML = '<table>'
                  total = 0
                  visiblePoints = 0

                  # Build an array of points to create our shared tooltip
                  points = chartFormatterService.getCategoryDataPoints(chart, this, $scope.range.min, visibleSeries)

                  for i,point of points

                    prefixValueSuffix = chartFormatterService.getPrefixValueSuffix(chart, point.y, true, $scope.range.min)
                    name = point.name

                    # Calculate percentages for stacked bars and other grouped data
                    formattedPercentage = ''
                    if prefixValueSuffix.suffix != "%" and chartFormatterService.isStacked(chart) # Percentages of a percentage don't make sense
                      if point.percentage? and points.length > 1
                        formattedPercentage = point.percentage.toFixed(0) + "%"

                    bold = ""

                    # Highlight the exact point we're hovering on for multi-series tooltips
                    if this.point.series.name is name and points.length > 1
                      bold = "font-weight:bold;"

                    # Build the tooltip HHTML
                    tooltipHTML += "<tr><td><span style='color: #{point.color}'>" + chartFormatterService.getDisplayName(name, $scope.chartWidth) + "</span></td><td style='#{bold}text-align:right;'>" + formattedPercentage + "</td><td class='value' style='#{bold}'>" + prefixValueSuffix.prefix + prefixValueSuffix.value + prefixValueSuffix.suffix + '</td></tr>'
                    total += point.y
                    visiblePoints++

                  # If we have multiple series, total everything up
                  if (visiblePoints > 1 or visiblePoints is 0) and chart.data?.suffix isnt "%" and chartFormatterService.isStacked(chart)
                    totalPrefixValueSuffix = chartFormatterService.getPrefixValueSuffix(chart, total, true, $scope.range)
                    tooltipHTML += '<tr class="total"><td><strong>Total:</strong></td><td class="value" colspan="2">' + totalPrefixValueSuffix.prefix + totalPrefixValueSuffix.value + totalPrefixValueSuffix.suffix + '</td></tr></table>'
                  else if visiblePoints is 0
                    tooltipHTML = ""
                    tooltipDiv = "<div class='chartTooltip empty'>"

                  tooltipHTML = tooltipDiv + tooltipHeader + tooltipHTML + '</div>'

                  return tooltipHTML
                else
                  if chart.chartStyle is 'PIE_CHART' or chartFormatterService.isStacked(chart)
                    # Format the values for the tooltip
                    pvs = chartFormatterService.getPrefixValueSuffix(chart, this.y, false, $scope.range)

                    if this.key is "Slice"
                      this.key = this.point.config[0]

                    # For stacked bar charts, the color is undefined and needs to be set in a different way
                    if !this.point.color?
                      this.point.color = this.point.graphic.fill

                    # Format the total for display
                    if pvs.suffix != "%"
                      formattedPercentage = this.point.percentage.toFixed(2) + "%"
                    else
                      formattedPercentage = null

                    # Create the whole display value
                    labelValue  = pvs.prefix + pvs.value + pvs.suffix

                    # Build the percentage row if we're showing it
                    if formattedPercentage?
                      percentRowHtml = "<tr><td>&nbsp;</td><td style='text-align: right'>#{formattedPercentage}</td></tr>"
                    else
                      percentRowHtml = ""

                    # Set the series name
                    seriesName = "Value"

                    if chartFormatterService.isStacked(chart)
                      seriesName = chartFormatterService.getDisplayName(this.series.name, $scope.chartWidth)

                    # Build HTML
                    formattedTooltip = "<div class='chartTooltip'>"
                    formattedTooltip += "<h4>#{this.key}</h4><table><tbody><tr><td><span style='color:#{this.point.color}'>#{seriesName}</span></td><td>#{labelValue}</td></tr>#{percentRowHtml}</tbody>"
                  else
                    # Using the single point tooltip here, usually because there are too many series to display properly
                    seriesName = chartFormatterService.getDisplayName(this.point.series.name, $scope.chartWidth)
                    label = this.key
                    pvs = chartFormatterService.getPrefixValueSuffix(chart, this.y, false, $scope.range)
                    labelValue = pvs.prefix + pvs.value + pvs.suffix
                    formattedTooltip = "<div class='chartTooltip'>"
                    formattedTooltip += "<h4>#{label}</h4><table><tbody><tr><td><span style='color:#{this.series.color}'>#{seriesName}</span></td><td>#{labelValue}</td></tr></tbody>"

                  formattedTooltip += "</table>"
                  formattedTooltip += "</div>"

                  return formattedTooltip
            plotOptions:
              line:
                marker:
                  enabled: chartFormatterService.getCategories(chart).length is 1
              area:
                marker:
                  enabled: chartFormatterService.getCategories(chart).length is 1
              series:
                animation: false
                pointPadding: 0.05
                groupPadding: 0
                stacking: chartFormatterService.isStacked(chart)
            exporting:
              enabled: $scope.exporting
              buttons:
                contextButton:
                  y: -13

          if chart.chartStyle is 'PIE_CHART'
            extraOptions = @getHighchartsPieChartOptions(chart)
          else
            extraOptions = @getHighchartStandardOptions(chart)

          chartOptions = $.extend(basicOptions, extraOptions)

          @highChart = new Highcharts.Chart(chartOptions)

        @renderScalar = (chart) ->
          $element.addClass("figure-content-scalar")
          @type = "scalar"
          onlySeries = chart.data.series[0]

          # TODO: truncated based on element width
          # truncValue = chartFormatterService.getPrefixValueSuffix(chart, onlySeries.data[0], true, $scope.range, true)
          prefixValueSuffix = chartFormatterService.getPrefixValueSuffix(chart, onlySeries.data[0], true, $scope.range, false)
          tooltipValue = prefixValueSuffix.prefix + prefixValueSuffix.value + prefixValueSuffix.suffix
          prefix = prefixValueSuffix.prefix
          # Use Helvetica for Thai bahts. We do this same formatting for figure-based scalars.
          if prefix.trim() is '฿' or prefix.trim() is '&#3647'
            prefix = '<span style="font-family: Helvetica">' + prefix + '</span>'
          fullValue = '<span class="prefix">' + prefix + '</span>' + prefixValueSuffix.value + '<span class="suffix">' + prefixValueSuffix.suffix + "</span>"
          html = '<div class="figure-content-scalar"><span class="scalar-value" data-container="body" data-original-title="' + tooltipValue + '" data-placement="right">' + fullValue + '</span></div>'
          $element.html(html)
          $element.find('.scalar-value').tooltip();

          @scalarFontSizer($element.height())

        @renderTable = (chart) ->
          @type = "table"

          chartContainer = $element[0]
          $element.css('font-size', 'inherit')

          createHeaderHtml = (seriesName) ->
              "<th>" + seriesName + "</th>"

          # Store the json to tell DataTables which sorting method to use for each column
          columnSortingJson = []

          tableHtml = createHeaderHtml(chart.data.categoryHeader)
          for i, series of chart.data.series
            tableHtml += createHeaderHtml(series.name)
            columnSortingJson.push('null') # Create an element for each column and giving it the default value for datatables

          tableHtml = "<thead><tr>" + tableHtml + "</tr></thead>"

          data = []
          for i in [0..chart.data.categories.length-1]
            row = []
            category = chart.data.categories[i]
            row[0] = category
            for j, series of chart.data.series
              if columnSortingJson[j] is 'null' # Keeping checking the data until we find something non-standard
                columnSortingJson[j] = chartFormatterService.getSortingJson(typeof series.data[i])
              prefixValueSuffix = chartFormatterService.getPrefixValueSuffix(chart, series.data[i], true, $scope.range)
              if prefixValueSuffix.value? and prefixValueSuffix.value != ""
                row[(+j + 1)] = prefixValueSuffix.prefix + prefixValueSuffix.value + prefixValueSuffix.suffix
              else #empty row if value is null
                row[(+j + 1)] = ''
            data.push row
          # Get category sorting method
          categorySort = chartFormatterService.getSortingJson( chart.data.categoryHeader )

          # Add one column to the front
          columnSortingJson.unshift( categorySort )

          html = "<div class='dataTable'><table class='table table-report table-skipBorder table-condensed' style='width:100%'>" + tableHtml + "</table></div>"
          $element.html(html)

          headerRowHeight = $element.find('thead').height()

          @table = $element.find('.dataTable table').dataTable(
            bScrollInfinite: true
            bScrollCollapse: true
            sScrollY: $element.height() - headerRowHeight
            sScrollX: "100%"
            iDisplayLength: Math.ceil(($element.height() - headerRowHeight) / 28)
            sSortAsc: "header headerSortDown"
            sSortDesc: "header headerSortUp"
            sSortable: "header"
            bFilter: false
            bInfo: false
            aaSorting: []   # Prevents us from sorting upon loading
            aoColumns: columnSortingJson
            bDestory: true
            searching: false
            paging: false
            search:
              smart: false
            info: false
          )
          @table.fnAddData(data)

          return

        renderQueued: false
        # End General Utility functions
        @renderChart = () ->
          $timeout ->
            smallItem = $element.height() < 300 or $element.width < 300
            $element.toggleClass('small', smallItem)
          $element.removeClass('calculating')
          unless $scope.chart?
            #no data on initial request so we are loading it asynchronously. show loading message
            $element.addClass("blocked loading")
            return
          if $scope.chart.error?
            $element.addClass('error')
            $element.removeClass("blocked loading")
            return
          unless $scope.chart.data?
            if $scope.chart.warnings.cacheInProgress
              $element.addClass('calculating')
              $element.addClass('blocked loading')
              return

          # Populate these values to use later (such as tooltip rendering)
          $scope.chartWidth = $element.width()
          $scope.chartHeight = $element.height()

          if $scope.chart.data.series.length is 0 or $scope.chart.data.series[0].data.length is 0
            $element.addClass('noData')
            $element.removeClass("blocked loading")
            $element.html("")
            return

          if @renderQueued
            return
          @renderQueued = true
          chartRenderQueue () =>
            @renderQueued = false
            unless $scope.chart.error? # in case there was an error before
              $element.removeClass('error')

            $element.removeClass("blocked loading")

            # Sort series before rendering so the colors match up on different charts if the series names are the same.
            # Note: If we have more than 100 series, it skips sorting and we shouldn't ever try to sort cohorts since they're already sorted by date
            unless chartFormatterService.isCohort($scope.chart) or $scope.chart.isComposite
              $scope.chart.data.series = chartFormatterService.sortSeriesByName($scope.chart.data.series)

            $scope.range = chartFormatterService.getMinMax($scope.chart.data.series, chartFormatterService.isStacked($scope.chart))
            if $scope.chart.chartStyle is 'TABLE'
              $element.removeClass "noData"
              @renderTable($scope.chart)
            else if $scope.chart.chartStyle is 'SCALAR'
              #this is here to check if the scalar value is null
              #in which case we should show a 'No Data' message
              if $scope.chart.data.series[0].data[0]?
                $element.removeClass "noData"
                @renderScalar($scope.chart)
              else
                $element.addClass('noData')
                $element.html("")
            else
              $element.removeClass "noData"

              @renderHighchart($scope.chart)

        @
    ]
    link: (scope, elem, attrs, controllers) ->
      chartController = controllers[0]
      gridster = controllers[1]

      scope.$on "gridsterItemResized", (event, width, height) ->
        chartController.resize width, height

      scope.$on "hideChartsAndFigures", (event) ->
        elem.hide()

      scope.$on "showChartsAndFigures", (event) ->
        elem.show()

      # re-render the chart if the data changes or if the error status changes
      scope.$watchGroup ['chart.data', 'chart.error'], (newChartValues, oldChartValues) ->
        chartController.renderChart() unless newChartValues is oldChartValues

      chartController.renderChart()


  ]
